
const StatusGabarit=[
  { value: "6", label: "Petit"},
  { value: "10", label: "Grand"},
];


export default StatusGabarit;

  